import styles from './styles.scss';
import { useToggle } from 'hooks';
import { isMobile } from 'components/Shared/responsive';
import connect from 'components/Shared/connect';
import { SectionBlock } from 'models/SectionBlock';
import { IconArrow } from 'components/Shared/Icon/themes/BGH-RD3/iconArrow';

interface MergedProps {
  question: string;
  answer: string;
  isMobile: boolean;
}

const _Faq = ({ question, answer, isMobile }: MergedProps) => {
  const [showQuestion, toggleShowQuestion] = useToggle(!isMobile);

  return (
    <div className={styles.item}>
      <div className={styles.title} onClick={toggleShowQuestion}>
        {question}
        <IconArrow
          size="small"
          appearance={showQuestion ? 'flip-270' : 'flip-90'}
          className={styles.filterArrow}
        />
      </div>
      {(showQuestion || !isMobile) && (
        <div className={styles.answer}>
          <div>{answer}</div>
        </div>
      )}
    </div>
  );
};

export const Faq = connect<MergedProps, SectionBlock>(state => ({
  isMobile: isMobile(state)
}))(_Faq);
